import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 18 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 17\" class=\"icon\" id=\"icon-home\">\r\n  <path id=\"icon-home_首页\" class=\"cls-1\" d=\"M379.491,139.66a0.485,0.485,0,0,1-.375-0.174,0.475,0.475,0,0,1,.066-0.675l8.026-6.538a1.264,1.264,0,0,1,1.589,0l8.028,6.538a0.476,0.476,0,0,1,.065.675,0.49,0.49,0,0,1-.683.065l-8.028-6.539a0.279,0.279,0,0,0-.352,0l-8.028,6.539A0.489,0.489,0,0,1,379.491,139.66Zm13.725,9.334H382.79a2.38,2.38,0,0,1-2.393-2.361v-8.519a0.486,0.486,0,0,1,.971,0v8.519a1.414,1.414,0,0,0,1.422,1.4h10.426a1.414,1.414,0,0,0,1.422-1.4v-8.519a0.485,0.485,0,0,1,.97,0v8.519A2.379,2.379,0,0,1,393.216,148.994Zm-2.649,0h-5.129v-5.052a2.3,2.3,0,0,1,2.315-2.285h0.5a2.3,2.3,0,0,1,2.314,2.285v5.052Zm-4.158-.958H389.6v-4.094a1.337,1.337,0,0,0-1.344-1.327h-0.5a1.337,1.337,0,0,0-1.344,1.327v4.094Z\" transform=\"translate(-379 -132)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home.svg
// module id = U9Ws
// module chunks = 127